module.exports = __webpack_public_path__ + "./img/tree.svg";